import HTTPClient from './http-client';

const END_POINT = '/siteverify';

const secretKey = `${process.env.VUE_APP_RECAPTCHA_SECRET}`

const googleRecaptchaResponse = async (token) =>{
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  return api.post(
    `${END_POINT}?secret=${secretKey}&response=${token.token}`
  );
}

export {
  googleRecaptchaResponse
}
